import { LabeledSwitch, LabeledSwitchProps } from '@components/switch';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormLabeledSwitchProps<T = unknown> = FormFieldProps<LabeledSwitchProps, T, boolean>;

export function FormLabeledSwitch<T>(props: FormLabeledSwitchProps<T>) {
  const formFieldProps = useFormField(props);

  return <LabeledSwitch {...props} {...formFieldProps} />;
}
